import { userComments } from '@/mocks/site';

export default function CommentsSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1 text-xs text-foreground-500 mb-2">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            用户评价
          </div>
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            吃瓜群众怎么说
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            听听其他吃瓜群众对黑料爆料吃瓜网的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {userComments.map((comment, idx) => (
            <div
              key={comment.id}
              className={`bg-background-50 rounded-lg p-5 border border-background-200/70 ${
                idx >= 3 ? 'opacity-60 hover:opacity-100 transition-opacity' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <h4 className="font-semibold text-sm text-foreground-900 mb-2">{comment.title}</h4>
              <p className="text-xs text-foreground-600 leading-relaxed mb-4">{comment.content}</p>
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.username}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-xs font-semibold text-foreground-900">{comment.username}</p>
                  <p className="text-[10px] text-foreground-500">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}